import React from 'react';
import { Animated, Text } from 'react-native';
import i18n from 'i18n-js';

import { Element, scale, notchTop } from '@components/frame';
import { isPhone } from '@helpers';

import { font } from '@styles/fonts';

export default ({ C }) => {
  return (
    <Animated.View
      style={{
        height: scale(147),
        width: '100%',
      }}
    >
      <Element
        {...{
          config: {
            position: {
              top: 67,
              left: 18,
            },
            height: 39,
          },
          configMobile: {
            position: {
              top: 57 + notchTop,
              left: 18,
            },
          },
        }}
      >
        <Text
          style={[
            {
              color: C('Label / Light / Primary'),
              fontWeight: '700',
            },
            font['Large Title'],
          ]}
        >
          {i18n.t('Search')}
        </Text>
      </Element>
    </Animated.View>
  );
};
